<template>
  <div>
    <van-tabs
      v-model="active"
      line-height="2px"
      color="#45B9BC"
      sticky
      :swipe-threshold="6"
      title-active-color="#45B9BC"
      @click="change_active()"
    >
      <van-tab v-for="(tabItem,tabIndex) in tabList" :key="tabIndex">
        <!--标签标题栏-->
        <div slot="title">{{tabItem.title}}</div>
        <!--订单为空-->
        <!-- <div class="order__emptyBox">
          <img src="/static/img/order_empty.png" alt />
          <p>暂无订单，快去逛逛吧~</p>
        </div>-->
        <!--订单内容-->
        <van-list
          v-model="tabItem.loading"
          :finished="tabItem.finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="order__listBox">
            <router-link
              :to="{path:'/tech_detail',query:{'order_id':orderItem.id}}"
              class="order__list"
              v-for="(orderItem,orderIndex) in tabItem.orderList"
              :key="orderIndex"
            >
              <div class="order__list_title flex">
                <span>{{orderItem.store_name}}</span>
                <span class="col_45B9BC" v-if="orderItem.oi_status == 0">待接单</span>
                <span class="col_45B9BC" v-if="orderItem.oi_status == 1">待服务</span>
                <span class="col_45B9BC" v-if="orderItem.oi_status == 2">已拒绝</span>
                <span class="col_45B9BC" v-if="orderItem.oi_status == 3">服务中</span>
                <span class="col_45B9BC" v-if="orderItem.oi_status == 4">已完成</span>
                <!-- <span class="col_45B9BC" v-else>已完成</span> -->
              </div>
              <div class="order__list_content">
                <div class="flex">
                  <span>{{orderItem.servicetitle}}</span>
                  <span>¥{{orderItem.price}}</span>
                </div>
                <div class="fs_12 order__content_subtitle">
                  <p class="col_999">预约时间：{{orderItem.starttime}}</p>
                  <p
                    v-if="orderItem.oi_status===1"
                    class="col_45B9BC"
                  > <span >{{orderItem.distance_text}}</span>
          <span class="">{{orderItem.distance_service}}</span></p>
                </div>
                <div v-if="orderItem.surplustime == '已过期' && orderItem.oi_status != 4 && orderItem.oi_status != 2" style="font-size:.7rem;color:#999;text-align:right;">订单已过期</div>
                <div v-else>
                  <!-- 待接单订单-按钮-->
                  <div class="order__content_btnBox" v-if="orderItem.oi_status==0">
                    <router-link :to="{path:'/tech_detail',query:{order_id:orderItem.id}}">取消订单</router-link>
                    <router-link
                      :to="{path:'/tech_detail',query:{order_id:orderItem.id}}"
                      class="order__btn2"
                    >确认接单</router-link>
                  </div>
                  <!-- 待服务订单-按钮-->
                  <div
                    class="order__content_btnBox"
                    v-if="orderItem.oi_status==1"
                    @click="begin_order(orderItem.id)"
                  >
                    <a class="order__btn2">开始服务</a>
                  </div>
                </div>
                <!-- 已完成订单-按钮-->
                <!-- <div class="order__content_btnBox" v-if="orderItem.oi_status==2">
                  <router-link to="/" class="order__btn2">扫码</router-link>
                </div>-->
              </div>
            </router-link>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import tabBar from "@/components/tabBar.vue";
export default {
  name: "tech_order",
  components: { tabBar },
  data() {
    return {
      active: 0,
      status: 99,
      loading: false,
      finished: true,
      page: 0,
      // 订单列表
      tabList: [
        {
          id: "0",
          title: "全部",
          // 加载更多
          loading: false,
          finished: true,
          orderList: []
        },
        {
          id: "1",
          title: "待接单",
          // 加载更多
          loading: false,
          finished: true,
          orderList: []
        },
        {
          id: "2",
          title: "待服务",
          // 加载更多
          loading: false,
          finished: true,
          orderList: []
        },
        {
          id: "3",
          title: "服务中",
          // 加载更多
          loading: false,
          finished: true,
          orderList: []
        },
        {
          id: "4",
          title: "已拒绝",
          // 加载更多
          loading: false,
          finished: true,
          orderList: []
        },
        {
          id: "5",
          title: "已完成",
          // 加载更多
          loading: false,
          finished: true,
          orderList: []
        }
      ]
    };
  },
  created() {
    if (this.$route.query.status == 99) {
      this.active = 0;
    }
    if (this.$route.query.status == 0) {
      this.active = 1;
    }
    if (this.$route.query.status == 1) {
      this.active = 2;
    }
    if (this.$route.query.status == 3) {
      this.active = 3;
    }
    if (this.$route.query.status == 2) {
      this.active = 4;
    }
    if (this.$route.query.status == 4) {
      this.active = 5;
    }
    if (this.$route.query.status) {
      this.status = this.$route.query.status;
    }
    if (!this.active) {
      this.active = 99;
    }
    this.init();
  },
  methods: {
    init() {
      this.get_order();
    },
    get_order() {
      let status = this.status;
      let active = this.active;
      if (this.active == 0) {
        status = 99;
      }
      if (this.active == 1) {
        status = 0;
      }
      if (this.active == 2) {
        status = 1;
      }
      if (this.active == 3) {
        status = 3;
      }
      if (this.active == 4) {
        status = 2;
      }
      if (this.active == 5) {
        status = 4;
      }
      if (this.active == 99) {
        status = 99;
        active = 0;
      }
      this.axios({
        url: this.api.order.get_tech_order, //获取用户信息
        data: { status: status }
      }).then(res => {
        if (res.error === 0) {
          this.tabList[active].orderList = res.tech_order;
        }
      });
    },
    begin_order(order_id = 0) {
      this.axios({
        url: this.api.order.tech_begin_order, //获取用户信息
        data: { order_id: order_id }
      }).then(res => {
        if (res.error === 0) {
          location.reload();
        }
      });
    },
    change_active() {
      this.get_order();
    },
    // 加载数据
    onLoad() {
      tabList_active.loading = false;
      tabList_active.finished = true;
      // 异步更新数据
      // setTimeout(() => {
      //   // 定义当前所在的数组
      //   var tabList_active = this.tabList[this.active];
      //   // 定义一个变量，取出当前数组的里的list
      //   var list = tabList_active["orderList"];
      //   for (let i = 0; i < 3; i++) {
      //     list.push(list[0]);
      //   }
      //   // 加载状态结束
      //   tabList_active.loading = false;

      //   // 数据全部加载完成
      //   if (list.length >= 10) {
      //     tabList_active.finished = true;
      //   }
      // }, 500);
    }
  }
};
</script>

<style scoped>
@import "../../../assets/css/order.css";
</style>



// WEBPACK FOOTER //
// src/views/technician/order/tech_order.vue